<template>
  <v-row align="center" class="list px-3 mx-auto">
    <!-- <v-col cols="12" md="8" class="mx-auto">
      <v-text-field v-model="title" label="Search by Title"></v-text-field>
        label="Filtrar por..."
        v-model="filtro"
      ></v-text-field>
    </v-col> -->

    <!-- <v-col cols="12" md="4">
      <v-btn small @click="searchTitle">
        Buscar
      </v-btn>
    </v-col> -->
    <v-col cols="12" sm="12">
      <v-card class="mx-auto">
        <v-card-title>
          <span class="mx-auto">Administración de Usuarios CPNU</span>
        </v-card-title>
        <v-card-subtitle>
          <v-text-field  
            label="Filtrar por..."
            v-model="filtro"
          ></v-text-field>
        </v-card-subtitle>
        <v-card-text>
            <!-- disable-pagination -->
          <v-data-table
            dense
            :items="getUsuarios"
            :headers="headers"
            :search="filtro"
            disable-pagination
            :hide-default-footer="true"
            class="mb-5"
          >
            <template v-slot:item.nombres="{ item }">
              <span>
                {{ item.nombres + ' ' + item.apellidos }}
              </span>
            </template>
            <template v-slot:item.activo="{ item }">
              <v-checkbox readonly v-model="item.activo" color="green darken-3" />
            </template>
            <template v-slot:item.deCPNU="{ item }">
              <v-checkbox readonly v-model="item.deCPNU" color="green darken-3" />
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon v-if="item.deCPNU" small class="mr-2" @click="editarUsuario(item.idUsuario)">fas fa-edit</v-icon>
            </template>   
            <!-- <template v-slot:[`item.actions`]="{ item }">
              <v-icon small class="mr-2" @click="editTutorial(item.id)">mdi-pencil</v-icon>
              <v-icon small @click="deleteTutorial(item.id)">mdi-delete</v-icon>
            </template> -->
            <!-- <v-pagination>
            </v-pagination> -->
          </v-data-table>
        </v-card-text>

        <!-- <v-card-actions v-if="tutorials.length > 0">
          <v-btn small color="error" @click="removeAllTutorials">
            Remove todo
          </v-btn>
        </v-card-actions> -->
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: "MainAccesoUsuarios",
  data: () => ({
      filtro: '',
      headers: [
        { text: "Usuario", align: "start", sortable: false, value: "usuario" },
        { text: "Nombre", value: "nombres", sortable: false },
        { text: "Teléfono", value: "telefono", sortable: false },
        { text: "Celular", value: "celular", sortable: false },
        { text: "Activo", value: "activo", sortable: false },
        { text: "De CPNU", value: "deCPNU", sortable: false },
        { text: "Acciones", value: "actions", sortable: false, align: "center"},
      ],
  }),
  methods: {
    ...mapActions('acceso',['fetchUsuarios']),
    ...mapMutations('acceso',['setUsuarioConfig']),
    editarUsuario(id){
      // this.$router.push({name:'MainAccesoEntidad', params: { id: -1} })
      let usuarioConfig = this.usuarioConfig
      
      // Extraer los datos del usuario
      const usuarios = this.getUsuarios
      const indiceUsuario = usuarios.findIndex(e=>e.idUsuario===id)
      this.setUsuarioConfig({
        email: usuarios[indiceUsuario].usuario,
        esNuevoEditar: false,
        desdeListado: true,
        indiceListado: indiceUsuario
      })
      
      this.$router.push({name:'MainAccesoUsuario', params: {id: id}})
    },
    
  },
  computed: {
    ...mapState('acceso', ['usuarioConfig']),
    ...mapGetters('acceso',['getUsuarios'])  

  },
  created() {
    // this.$store.dispatch("acceso/fetchUsuarios");
    this.fetchUsuarios()
  }
};
</script>
